import { GET, POST, PUT, DELETE } from "../utils/restUtils";
import { Auth } from 'aws-amplify';
import _ from "lodash";

const getToken = async () => {
  let session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}

export const getCompanies = async config => {
  let token = await getToken();
  return await GET("/company",{
    headers: {
      'Authorization': token
    }
  });
};



export default {
  getCompanies,
};
